/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  ApiDepartmentCreateRequest,
  ApiDepartmentFilterRequest,
  ApiDepartmentUpdateRequest,
  DepartmentDto,
  DepartmentResponse,
  PaginatedResponseDepartmentWithUsersResponseDepartmentPagedMeta,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiDepartmentsController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-departments-controller
   * @name GetDepartmentById
   * @request GET:/api/v1/departments/{id}
   */
  getDepartmentById = (id: string, params: RequestParams = {}) =>
    this.http.request<DepartmentResponse, any>({
      path: `/v1/departments/${id}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getDepartmentByIdPath = '/v1/departments/${id}'
  static getDepartmentByIdMethod = 'GET'
  /**
   * No description
   *
   * @tags api-departments-controller
   * @name UpdateDepartment
   * @request PUT:/api/v1/departments/{id}
   */
  updateDepartment = (id: string, data: ApiDepartmentUpdateRequest, params: RequestParams = {}) =>
    this.http.request<DepartmentResponse, any>({
      path: `/v1/departments/${id}`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateDepartmentPath = '/v1/departments/${id}'
  static updateDepartmentMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-departments-controller
   * @name DeleteDepartment
   * @request DELETE:/api/v1/departments/{id}
   */
  deleteDepartment = (id: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/departments/${id}`,
      method: 'DELETE',
      ...params,
    })

  static deleteDepartmentPath = '/v1/departments/${id}'
  static deleteDepartmentMethod = 'DELETE'
  /**
   * No description
   *
   * @tags api-departments-controller
   * @name CreateDepartment
   * @request POST:/api/v1/departments
   */
  createDepartment = (data: ApiDepartmentCreateRequest, params: RequestParams = {}) =>
    this.http.request<DepartmentResponse, any>({
      path: `/v1/departments`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createDepartmentPath = '/v1/departments'
  static createDepartmentMethod = 'POST'
  /**
   * No description
   *
   * @tags api-departments-controller
   * @name GetDepartmentPaged
   * @request POST:/api/v1/departments/paged
   */
  getDepartmentPaged = (data: ApiDepartmentFilterRequest, params: RequestParams = {}) =>
    this.http.request<PaginatedResponseDepartmentWithUsersResponseDepartmentPagedMeta, any>({
      path: `/v1/departments/paged`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getDepartmentPagedPath = '/v1/departments/paged'
  static getDepartmentPagedMethod = 'POST'
  /**
   * No description
   *
   * @tags api-departments-controller
   * @name GetDepartmentsForCurrentOrg
   * @request GET:/api/v1/departments/org
   */
  getDepartmentsForCurrentOrg = (params: RequestParams = {}) =>
    this.http.request<DepartmentDto[], any>({
      path: `/v1/departments/org`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getDepartmentsForCurrentOrgPath = '/v1/departments/org'
  static getDepartmentsForCurrentOrgMethod = 'GET'
}
